<script setup lang="ts">
import Card from 'primevue/card';
import Skeleton from 'primevue/skeleton';

defineProps<{
  itemCount?: number;
}>();

const CARD_PT = {
  root: '!rounded-none !shadow-none',
  body: '!p-6 !pt-4 !pb-12',
} as const;
</script>

<template>
  <Card class="!bg-surface-container-lowest overflow-hidden" :pt="CARD_PT">
    <template #header>
      <div class="flex items-center justify-between px-6 pt-4">
        <Skeleton width="200px" height="28px" />
      </div>
    </template>

    <template #content>
      <div class="divide-y divide-surface-container overflow-hidden bg-surface border rounded-lg">
        <div v-for="n in itemCount ?? 3" :key="n" class="flex items-center gap-4 px-4 py-2">
          <!-- Avatar skeleton -->
          <Skeleton shape="circle" size="3rem" />

          <!-- Title skeleton -->
          <Skeleton width="120px" height="20px" class="flex-1" />

          <!-- Chips skeleton -->
          <div class="flex gap-2 flex-shrink-0">
            <Skeleton width="80px" height="28px" borderRadius="4px" />
            <Skeleton width="80px" height="28px" borderRadius="4px" />
          </div>
        </div>
      </div>
    </template>
  </Card>
</template>
